// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.servicesPageContainer {
  margin: auto;
  text-align: center;
}

.servicesContentContainer {
  margin: auto;
  display:flex;
  justify-content: center;
  width: 75%
}

.servicesColumn {
  flex: 1 1
}`, "",{"version":3,"sources":["webpack://./src/pages/Services.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB;AACF;;AAEA;EACE;AACF","sourcesContent":[".servicesPageContainer {\n  margin: auto;\n  text-align: center;\n}\n\n.servicesContentContainer {\n  margin: auto;\n  display:flex;\n  justify-content: center;\n  width: 75%\n}\n\n.servicesColumn {\n  flex: 1\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
